/**
 * Match a URL pathname against a glob-like pattern.
 * Patterns match against the pathname only (not origin/query).
 *
 * Examples:
 *   "*"          → matches everything
 *   "/pricing"   → exact match
 *   "/pricing*"  → starts with /pricing
 *   "/blog/*"    → starts with /blog/
 */
export function matchUrl(pattern: string | undefined, url: string): boolean {
  if (!pattern || pattern === "*") return true;

  let pathname: string;
  try {
    pathname = new URL(url).pathname;
  } catch {
    pathname = url;
  }

  if (pattern.endsWith("*")) {
    return pathname.startsWith(pattern.slice(0, -1));
  }

  return pathname === pattern;
}
